import { CommonButton } from '@Components/common/Button';
import styled, { css } from 'styled-components';
import { mq } from 'stylesheets/utils';

export const CheckoutStepsWrapper = styled.div``;
export const Step = styled.div`
  width: 42px;
  height: 42px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s ease all;
  border: 1px solid ${({ theme }) => theme.colors.innerProduct.gray};
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font600};
  color: ${({ theme }) => theme.colors.darkGray};
  background-color: ${({ theme }) => theme.colors.innerProduct.gray};
  margin-right: 26px;
`;
export const MainCollapseHeader = styled.div<{
  readonly active?: boolean;
}>`
  cursor: pointer;
  padding: 7px 18px;
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  border: 1px solid ${({ theme }) => theme.colors.lightPurple};
  border-radius: 4px;
  transition: 0.3s ease border-color, 0.3s ease background-color;
  user-select: none;
  height: 56px;
  display: flex;
  align-items: center;
  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => theme.colors.innerProduct.gray};
      border-color: ${({ theme }) => theme.colors.innerProduct.gray};
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      ${Step} {
        border-color: ${({ theme }) => theme.colors.auth.blue};
        color: ${({ theme }) => theme.colors.auth.blue};
        background-color: ${({ theme }) => theme.colors.babyBlue};
      }
    `}
`;
export const MainCollapseContent = styled.div`
  padding: 24px 38px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.innerProduct.gray};
  border-top: none;
  transition: 0.3s ease box-shadow;
  ${mq(576)} {
    padding: 24px 12px;
  }
`;
export const MainCollapseWrapper = styled.div<{ readonly isActive: boolean }>`
  margin-bottom: 26px;
  ${({ isActive }) =>
    isActive &&
    css`
      ${MainCollapseContent} {
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      }
    `}
`;
export const SubCollapseWrapper = styled.div`
  width: 100%;
  margin-bottom: 36px;
`;
export const SubCollapseCheck = styled.div`
  max-width: 20px;
  min-width: 20px;
  height: 20px;
  border: 1px solid ${({ theme }) => theme.colors.lightPurple};
  border-radius: 50%;
  position: relative;
  transition: 0.4s ease border-color;
  &::after {
    transition: 0.2s ease background-color;
    position: absolute;
    content: '';
    width: 12px;
    height: 12px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
  }
  ${mq(576)} {
    max-width: 16px;
    min-width: 16px;
    height: 16px;
    &::after {
      width: 10px;
      height: 10px;
    }
  }
`;
export const SubCollapseHeaderInner = styled.div`
  padding: 20px;
  display: flex;
  gap: 18px;
  flex: 1;
  align-items: center;
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black2};
  border: 1px solid ${({ theme }) => theme.colors.lightPurple};
  border-radius: 4px;
  transition: 0.4s ease border-color, 0.4s ease background-color;
`;
export const SubCollapseIcon = styled.div<{ readonly icon: string }>`
  min-width: 42px;
  max-width: 42px;
  height: 40px;
  mask-image: ${({ icon }) => `url('/${icon}')`};
  mask-size: fill;
  mask-repeat: no-repeat;
  background-color: ${({ theme }) => theme.colors.lightPurple};
`;
export const SubCollapseHeader = styled.div<{ readonly isActive: boolean; readonly isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  &:hover {
    ${SubCollapseCheck} {
      border-color: ${({ theme }) => theme.colors.auth.blue};
    }
    ${SubCollapseHeaderInner} {
      border-color: ${({ theme }) => theme.colors.auth.blue};
    }
  }
  ${({ isActive }) =>
    isActive &&
    css`
      ${SubCollapseCheck} {
        border-color: ${({ theme }) => theme.colors.auth.blue};
        &::after {
          background-color: ${({ theme }) => theme.colors.auth.blue};
        }
      }
      ${SubCollapseHeaderInner} {
        border-color: ${({ theme }) => theme.colors.auth.blue};
        background-color: ${({ theme }) => theme.colors.babyBlue};
      }
      ${SubCollapseIcon} {
        background-color: ${({ theme }) => theme.colors.auth.blue};
      }
    `}
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
      ${SubCollapseHeaderInner} {
        background-color: ${({ theme }) => theme.colors.lightenGray};
      }
    `}
`;
export const SubCollapseHeaderInfo = styled.div`
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  line-height: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const SubInfo = styled.div`
  font-size: ${({ theme }) => theme.fontsizes.body14};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
`;
export const SubCollapseContent = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.arrowBackground};
  margin-left: 32px;
  margin-top: -4px;
  padding: 20px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  ${mq(576)} {
    margin-left: 28px;
  }
`;
export const SubCollapseTitle = styled.h4`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  margin-bottom: 14px;
  line-height: 1;
`;
export const MainCollapseFooter = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.innerProduct.gray};
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
`;
export const MainCollapseAction = styled(CommonButton)`
  min-width: 124px;
  height: 48px;
`;
export const PickupListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  ${mq(992)} {
    /* flex-direction: column; */
  }
`;
export const BranchesSection = styled.div`
  flex: 1;
`;
export const BranchesList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  max-height: 240px;
  margin-bottom: 12px;
`;
export const PickupMapWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
  margin-top: 30px;
`;
export const MapWrapper = styled.div``;
export const PaymentMethodsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
export const PickupFormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const SavePickupPointBtn = styled(CommonButton)`
  width: auto;
  display: inline-flex;
  flex: auto 0;
`;
